import { AssumedDeals } from './AssumedDeals';

export default AssumedDeals;
